import useBodyScrollLock from "@/hooks/useBodyScrollLock";
import styles from "./SessionExpiredModal.module.css";

export default function SessionExpiredModal({ open, loading = false, onLogout }) {
  useBodyScrollLock(open);

  if (!open) return null;

  return (
    <div className={styles.root} role="presentation">
      <div className={styles.overlay} aria-hidden="true" />

      <div
        className={styles.modal}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-expired-title"
        aria-describedby="session-expired-desc"
      >
        <h2 id="session-expired-title" className={styles.title}>
          Session Expired
        </h2>
        <p id="session-expired-desc" className={styles.description}>
          Your session has expired. Please log out and sign in again to continue.
        </p>

        <button
          type="button"
          className={styles.logoutBtn}
          onClick={onLogout}
          disabled={loading}
        >
          {loading ? "Logging out..." : "Logout"}
        </button>
      </div>
    </div>
  );
}
